import { useMemo } from "react";
import SCard from "./SCard";
import { numberToCurrency } from "utils";
import { Avatar, Flex, Text } from "@chakra-ui/react";
import { getImageWithSubRoute } from "utils";
import useTotalTVL from "@hooks/useTotalTvl";

function getTotalKelpMiles() {
  const BASE_VALUE = 523_0_000_000_000;
  const CHANGE_PER_HOUR = (250 * 1_000_000_000) / 24;
  const STARTING_TIME = Date.parse(
    "Wed Apr 23 2025 10:45:23 GMT+0530 (India Standard Time)"
  );

  const now = Date.now();
  const hoursSinceStart = (now - STARTING_TIME) / (1000 * 60 * 60);
  return BASE_VALUE + CHANGE_PER_HOUR * hoursSinceStart;
}

const KelpStatsCard = () => {
  // const [isVisible, setIsVisible] = useState(false);

  const { totalStaked } = useTotalTVL();

  const items = useMemo(() => {
    return [
      {
        label: "TVL",
        value: totalStaked ? `$${numberToCurrency(`${totalStaked}`, 2)}` : "-",
        icon: "tvl.svg",
      },

      {
        label: "Total Kernel Points",
        value: `${numberToCurrency(
          (getTotalKelpMiles() / 1000).toString(),
          2
        )}`,
        icon: "kelp-miles.svg",
      },
    ];
  }, [totalStaked]);

  return (
    <SCard title="Kelp Stats">
      <Flex direction="column" gap={4}>
        {items.map((item, index) => (
          <div key={index}>
            {item.value ? (
              <Flex key={item.label} gap={4} alignItems="center">
                <Avatar
                  w={9}
                  h={9}
                  src={getImageWithSubRoute(
                    `/assets/right-sidebar/${item.icon}`
                  )}
                />
                <Flex
                  lineHeight={1.3}
                  direction={{
                    base: "row-reverse",
                    xl: "column",
                  }}
                  justify="space-between"
                  flex={1}
                >
                  <Text fontWeight={700} fontSize={14} color="#075A5A">
                    {item.value}
                  </Text>
                  <Flex gap="4px" alignItems="center">
                    <Text fontSize={12} color="#3F6870" whiteSpace={"nowrap"}>
                      {item.label}
                    </Text>
                    {/* {item.label.toLowerCase() === "tvl" && totalStaked ? (
                      <Box fontSize="16px">
                        <Tooltip
                          placement="bottom"
                          backgroundColor="#075A5A"
                          borderRadius="8px"
                          p="6px 12px"
                          pointerEvents="all"
                          isOpen={isVisible}
                          closeDelay={2000}
                          onClose={() => setIsVisible(false)}
                          label={
                            <Flex flexDir="column" w="160px">
                              <Text
                                fontSize={{ base: "12px", md: "16px" }}
                                color="#FFF"
                                fontWeight="600"
                              >
                                TVL
                              </Text>
                              <Flex
                                flexDir="column"
                                fontSize={{ base: "10px", md: "14px" }}
                                color="#A1B6BA"
                                fontWeight="400"
                                lineHeight={{ base: "16px", md: "20px" }}
                              >
                                <Flex items-center justify="space-between">
                                  {restakeTvl && (
                                    <>
                                      <Text>Restake TVL</Text>
                                      <Text>
                                        {`$${numberToCurrency(
                                          restakeTvl?.toString()
                                        )}`}
                                      </Text>
                                    </>
                                  )}
                                </Flex>
                                <Flex items-center justify="space-between">
                                  <Text>Gain TVL</Text>
                                  {`$${numberToCurrency(gainTvl.toString())}`}
                                </Flex>
                              </Flex>
                            </Flex>
                          }
                        >
                          <Box fontSize={{ base: "12px", md: "16px" }}>
                            <AiOutlineInfoCircle
                              onMouseEnter={() => setIsVisible(true)}
                              onClick={() => setIsVisible(true)}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    ) : null} */}
                  </Flex>
                </Flex>
              </Flex>
            ) : null}
          </div>
        ))}
      </Flex>
    </SCard>
  );
};

export default KelpStatsCard;
